module.exports = __webpack_public_path__ + "img/product-list_m7.e9584956.png";